// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination[data-v-e98b1c1a] .el-pagination .btn-next .el-icon,.pagination[data-v-e98b1c1a] .el-pagination .btn-prev .el-icon{font-size:25px;padding-top:8px}.pagination[data-v-e98b1c1a] .el-pagination .btn-prev{margin-right:15px}.pagination[data-v-e98b1c1a] .el-pagination .el-pager li{font-size:18px;border-radius:50%;width:40px;height:40px;padding-top:4px;margin-right:15px}.pagination[data-v-e98b1c1a] .el-pagination .el-pager .active{color:#fff;background-color:#021dac}", ""]);
// Exports
module.exports = exports;
